import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../css/components/controls/HrnbDatePicker.css";

function toLocalDateString(date) {
    // Форматируем Date в yyyy-MM-dd по локальному времени
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export default function HrnbDatePicker({
                                           label,
                                           value,
                                           onChange,
                                           minDate,
                                           maxDate,
                                           disabled = false,
                                           className = "",
                                           error = "",
                                           hint = "",
                                           placeholder = "Выберите дату",
                                           ...props
                                       }) {
    // Парсим строку yyyy-MM-dd в Date с полуднем, чтобы избежать сдвига часового пояса
    const selectedDate = value ? new Date(`${value}T12:00:00`) : null;

    return (
        <div className={`hrnb-datepicker-wrap ${className} ${disabled ? "hrnb-datepicker--disabled" : ""}`}>
            {label && <label className="hrnb-datepicker__label">{label}</label>}
            <ReactDatePicker
                selected={selectedDate}
                onChange={date => onChange(date ? toLocalDateString(date) : "")}
                minDate={minDate ? new Date(`${minDate}T12:00:00`) : undefined}
                maxDate={maxDate ? new Date(`${maxDate}T12:00:00`) : undefined}
                disabled={disabled}
                placeholderText={placeholder}
                dateFormat="dd.MM.yyyy"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                scrollableYearDropdown
                yearDropdownItemNumber={100}
                className={`hrnb-datepicker__input${error ? " hrnb-datepicker__input--error" : ""}`}
                calendarClassName="hrnb-datepicker__calendar"
                popperClassName="hrnb-datepicker__popper"
                {...props}
            />
            {error
                ? <div className="hrnb-datepicker__error">{error}</div>
                : hint && <div className="hrnb-datepicker__hint">{hint}</div>
            }
        </div>
    );
}
